import {
  HStack,
  Text,
  Dialog,
  DialogContent,
  VStack,
  DialogOverlay,
  DialogFooter,
  Button,
  DialogTitle,
} from 'ui_2';
import happy_5 from '../../public/assets/highRes/5_happy.png';
import { useNavigate } from '@tanstack/react-router';
import { Route as IndexRoute } from '@src/routes/index';
import useWindowDimensions from '@src/hooks/useWindowDimensions';
import { useSquashGameState } from '@src/providers/squashGameState';
import _ from 'lodash';

export const GameCompleteDialog = () => {
  const { gameOver, setGameOver } = useSquashGameState();
  const navigate = useNavigate();
  const { height } = useWindowDimensions();
  const handlePlayAgain = () => {
    navigate({ to: IndexRoute.to });
    setGameOver?.(false);
  };

  return (
    <Dialog
      defaultOpen={gameOver}
      open={gameOver}
      onOpenChange={(open) => {
        if (!open) {
          setGameOver?.(false);
        }
      }}
    >
      <DialogOverlay className='bg-black/35' />
      <DialogContent
        showClose={false}
        aria-describedby='account-description'
        className='fixed h-3/5 w-[90%] max-w-[400px] bg-gray-50'
        style={{ borderRadius: 30 }}
      >
        <DialogTitle className='sr-only'>Game Complete</DialogTitle>
        <VStack className='h-full justify-center'>
          <div
            className={`${
              height > 700 ? 'mt-0' : '-mt-6'
            } flex origin-[50%_75%] animate-breathe justify-center`}
          >
            <img className='w-[85%]' src={happy_5} alt='Squash' />
          </div>
          <Text
            font={height > 700 ? 'bold-md' : 'bold-sm'}
            color='black'
            className='-mt-20 text-center'
          >
            Congratulations! <br />
            You conquered every level and grew the Ultimate Squash!
          </Text>
        </VStack>
        <DialogFooter className='w-full'>
          <HStack className='absolute bottom-8 left-0 w-full justify-center px-4 pb-safe'>
            <Button
              variant='primary'
              className='w-full max-w-[400px]'
              onClick={handlePlayAgain}
            >
              Play Again
            </Button>
          </HStack>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
